import {
    COUNTRYANDSTATE_LOADING, GET_COUNTRYANDSTATE_DATA_SUCCESS,
    GET_COUNTRYANDSTATE_DATA_ERROR, COUNTRYANDSTATE_END_LOADING, RESET_COUNTRYANDSTATE
} from "../actions/actionCountryAndState";
import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "countryandstates";

const initialState = {
    countryandstate: loadState(sessionKey, []),
    loading: false,
    countryandstaterror: ''
};

function reducerCountryAndState(state = initialState, action) {

    switch (action.type) {
        case COUNTRYANDSTATE_LOADING: {
            saveState(sessionKey, []);
            return {
                ...state,
                loading: true,
                countryandstate: [],
                countryandstaterror: ''
            };
        }

        case GET_COUNTRYANDSTATE_DATA_SUCCESS: {
            let cs = [
                ...action.payload
            ]

            saveState(sessionKey, cs);

            return {
                ...state,
                loading: false,
                countryandstate: cs,
                countryandstaterror: ''
            };
        }


        case GET_COUNTRYANDSTATE_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                countryandstate: [],
                countryandstaterror: action.error
            }
        }

        case COUNTRYANDSTATE_END_LOADING: {
            return {
                ...state,
                loading: false
            }
        }

        case RESET_COUNTRYANDSTATE: {
            return {
                ...state,
                countryandstate: [],
                loading: false,
                countryandstaterror: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerCountryAndState;